import '@fontsource-variable/inter/wght.css';
import './style/themes/palette.css';
import './style/themes/light.css';
import './style/themes/dark.css';
import './style/themes/midnight.css';
import './style/index.css';
import './style/themes/refined-light.css';
import './style/themes/refined-dark.css';
import './style/refined.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { send } from '@/api/send';
import { App } from '@/App';
import { applySkin, applyTheme, type ThemeName } from '@/store/prefs';

async function bootstrap(): Promise<void> {
  const { worker } = await import('@/mocks/browser');
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: { url: '/mockServiceWorker.js' },
  });

  // Read the theme before the first paint so the shell never flashes light.
  const globalPrefs = await send('load-global-prefs');
  applySkin(globalPrefs.skin);
  applyTheme(
    (globalPrefs.theme as ThemeName | undefined) ?? 'light',
    globalPrefs.preferredDarkTheme ?? 'dark',
  );

  const container = document.getElementById('root');
  if (!container) throw new Error('#root is missing from index.html');

  createRoot(container).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}

void bootstrap();
